var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-environment-sticker__square",style:(_vm.containerStyles)},[_c('p',{staticClass:"v-environment-sticker__label",style:(_vm.labelStyles)},[_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }